import React, { useState } from 'react';
import { Prompt } from '../../../../store/prompt/types';
import Button from '../../../../components/UI/Button';
import PromptForm from './PromptForm';
import Modal from '../../../../components/UI/Modal';
import { Heading, Text } from '../../../../components/Typography/Typography';
import styles from './PromptCard.module.scss';

interface PromptCardProps {
  prompt: Prompt;
}

const PromptCard: React.FC<PromptCardProps> = ({ prompt }) => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);

  const truncatedContent =
    prompt.content.length > 200 ? `${prompt.content.slice(0, 200)}...` : prompt.content;

  const handleCardClick = (e: React.MouseEvent) => {
    // Don't open view modal if clicking the edit button
    if (!(e.target as HTMLElement).closest('button')) {
      setIsViewModalOpen(true);
    }
  };

  return (
    <>
      <div className={styles.card} onClick={handleCardClick}>
        <div className={styles.header}>
          <Heading level={4} className={styles.title}>
            {prompt.name}
          </Heading>
          <Button variant="ghost" size="large" onClick={() => setIsEditModalOpen(true)}>
            Edit
          </Button>
        </div>
        <Text size="small" color="neutral-600" className={styles.description}>
          {prompt.description}
        </Text>
        {prompt.tag && (
          <Text element="span" size="small" className={styles.tag}>
            {prompt.tag}
          </Text>
        )}
        <Text size="base" className={styles.content}>
          {truncatedContent}
        </Text>
      </div>

      <Modal
        isOpen={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
        title={`Edit ${prompt.name}`}
        size="large"
      >
        <PromptForm initialValues={prompt} onSubmit={() => setIsEditModalOpen(false)} mode="edit" />
      </Modal>

      <Modal
        isOpen={isViewModalOpen}
        onClose={() => setIsViewModalOpen(false)}
        title={prompt.name}
        size="large"
      >
        <div className={styles.viewModal}>
          <Text size="small" color="neutral-600" className={styles.description}>
            {prompt.description}
          </Text>
          {prompt.tag && (
            <Text element="span" size="small" className={styles.tag}>
              {prompt.tag}
            </Text>
          )}
          <Text size="base" className={styles.fullContent}>
            {prompt.content}
          </Text>
        </div>
      </Modal>
    </>
  );
};

export default PromptCard;
